require('jquery-validation');
require('jquery-validation/dist/localization/messages_es');

require('select2');
require('select2/dist/js/i18n/es');


